import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    console.log('📍 Analytics detectó cambio de ruta:', location.pathname);
    
    // Esperar medio segundo a que gtag esté listo
    const timer = setTimeout(() => {
      if (typeof window.gtag === 'function') {
        console.log('✅ Enviando pageview a GA:', location.pathname);
        window.gtag('config', 'G-96X2F322DL', {
          page_path: location.pathname + location.search,
        });
      } else {
        console.log('❌ window.gtag no está disponible');
      }
    }, 500);
    
    return () => clearTimeout(timer);
  }, [location]);

  return null;
}

export default Analytics;